// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1qztx","tab":"ProcedureTabs_tab__2_Vn3"};